document.addEventListener('DOMContentLoaded', function () {
  const mapSingleElements = document.querySelectorAll('.map-single');
  if (!mapSingleElements.length) return;

  mapSingleElements.forEach(el => {
    // Datos del único punto (puedes personalizar si son varios)
    const location = {
      name: "Mi Negocio",
      coords: [42.054621, -6.634209],
      short: "Descripción breve de la ubicación.",
      image: "https://via.placeholder.com/320x200?text=Mi+Negocio",
      link: "#"
    };

    // Crear el mapa
    const mapSingle = L.map(el, {
      scrollWheelZoom: false
    }).setView(location.coords, 16);

    // Capa base
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(mapSingle);

    // Icono personalizado
    const singleIcon = L.divIcon({
      className: 'map-icon',
      iconSize: [24, 50],
      iconAnchor: [12, 50],
      popupAnchor: [0, -50]
    });

    // Contenido del popup
    const popupHtml = `
      <div style="max-width:260px">
        <img src="${location.image}" alt="${location.name}" style="width:100%;border-radius:6px;margin-bottom:6px;">
        <strong>${location.name}</strong><br>
        <span style="opacity:.9">${location.short}</span><br>
        <a href="${location.link}" target="_blank" rel="noopener" style="display:inline-block;margin-top:6px;">Más información</a>
      </div>
    `;

    // Añadir marcador
    L.marker(location.coords, { icon: singleIcon })
      .addTo(mapSingle)
      .bindPopup(popupHtml);
  });
});